import { get as getProp } from 'lodash';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { PERFORM_SINGLE_ACTION } from '../constants';
import { EDIT_USER, RESET_PASSWORD } from '../constants/single_actions';
import {
  performSingleActionSuccess,
  performSingleActionFailure,
  updateUserDisplay,
} from '../actions';
import {
  commentSelector,
  profileUpdateSelector,
  singleActionTypeSelector,
  userIdSelector,
} from '../selectors/singleActionsSelector';

const createSingleActionSagas = (api) => {
  function* updateUserSaga() {
    const profileUpdate = yield select(profileUpdateSelector);
    const userId = yield select(userIdSelector);
    const comment = yield select(commentSelector);
    try {
      const response = yield call(api.updateUser, {
        comment,
        profileUpdate,
        userId,
      });
      const user = getProp(response, 'data.data.attributes', {});
      yield put(performSingleActionSuccess());
      yield put(updateUserDisplay({
        user,
      }));
    } catch (error) {
      // The only real error messaging we have is Duplicate Email/Phone
      // TODO: Evaluate with QA any specific error cases
      // TODO: Evaluate with QA if it would be good if we validate form fields
      // before submitting, so that the only errors to really be concerned about
      // are duplicate email/phone
      const displayError = getProp(error, 'response.data.errors.0.detail', '');
      const statusCode = getProp(error, 'response.status', -1);
      yield put(performSingleActionFailure({
        error: displayError,
        statusCode,
      }));
    }
  }

  function* resetPasswordSaga() {
    const userId = yield select(userIdSelector);
    const comment = yield select(commentSelector);
    try {
      yield call(api.resetPassword, {
        comment,
        userId,
      });
      yield put(performSingleActionSuccess());
    } catch (error) {
      const displayError = getProp(error, 'response.data.errors.0.detail', '');
      const statusCode = getProp(error, 'response.status', -1);
      yield put(performSingleActionFailure({ error: displayError, statusCode }));
    }
  }

  function* performSingleAction() {
    const singleAction = yield select(singleActionTypeSelector);
    /* eslint-disable default-case */
    switch (singleAction) {
      case EDIT_USER:
        yield call(updateUserSaga);
        break;
      case RESET_PASSWORD:
        yield call(resetPasswordSaga);
        break;
    }
    /* eslint-enable default-case */
  }

  function* watchSingleActionSubmission() {
    yield takeLatest(PERFORM_SINGLE_ACTION, performSingleAction);
  }

  return {
    watchSingleActionSubmission,
  };
};

export default createSingleActionSagas;



// WEBPACK FOOTER //
// ./src/js/redux/sagas/singleActionSaga.js